import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  padding-right: 35px;\n  position: relative;\n  margin: 10px 0 15px;\n\n  @media (max-width: ', ') {\n    padding-right: 15px;\n  }\n'], ['\n  padding-right: 35px;\n  position: relative;\n  margin: 10px 0 15px;\n\n  @media (max-width: ', ') {\n    padding-right: 15px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n\n  h6 {\n    font-weight: 400;\n  }\n\n  svg {\n    margin-right: 5px;\n    transition: 0.3s transform ease-in-out;\n    width: 14px;\n  }\n\n  &::after {\n    background-color: ', ';\n    bottom: -4px;\n    content: \'\';\n    height: 1px;\n    left: 0;\n    position: absolute;\n    width: 100%;\n  }\n\n  ', '\n'], ['\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n\n  h6 {\n    font-weight: 400;\n  }\n\n  svg {\n    margin-right: 5px;\n    transition: 0.3s transform ease-in-out;\n    width: 14px;\n  }\n\n  &::after {\n    background-color: ', ';\n    bottom: -4px;\n    content: \'\';\n    height: 1px;\n    left: 0;\n    position: absolute;\n    width: 100%;\n  }\n\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n      svg {\n        transform: rotate(180deg);\n      }\n    '], ['\n      svg {\n        transform: rotate(180deg);\n      }\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      grid-template-columns: repeat(6, 1fr);\n    '], ['\n      grid-template-columns: repeat(6, 1fr);\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      grid-template-columns: repeat(2, 1fr);\n    '], ['\n      grid-template-columns: repeat(2, 1fr);\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      display: block;\n    '], ['\n      display: block;\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  display: grid;\n  margin: 15px 0 30px;\n  ', '\n\n  ', '\n'], ['\n  display: grid;\n  margin: 15px 0 30px;\n  ', '\n\n  ', '\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n      display: none;\n    '], ['\n      display: none;\n    ']);

import styled, { css } from 'styled-components';

export var StyledWrapper = styled.div(_templateObject, function (props) {
  return props.theme.tabletWidth;
});

export var StyledButton = styled.button(_templateObject2, function (props) {
  return props.theme.dormifyLightGrey;
}, function (_ref) {
  var active = _ref.active;
  return !active && css(_templateObject3);
});

var UlStyleTypes = function UlStyleTypes(_ref2) {
  var type = _ref2.type;

  if (type === 'swatch') {
    return css(_templateObject4);
  } else if (type == 'btn') {
    return css(_templateObject5);
  } else {
    return css(_templateObject6);
  }
};

export var StyledUl = styled.ul(_templateObject7, UlStyleTypes, function (_ref3) {
  var active = _ref3.active;
  return !active && css(_templateObject8);
});